import Vue from 'vue';
import VueGtag from 'vue-gtag';
import appConfig from './../store/modules/config';

Vue.use(VueGtag, {
  config: { id: appConfig.state.analytics.ga4Id }
});
